import isEmpty from 'lodash/isEmpty';
import moment from 'moment';
import { useMemo } from 'react';
import { SensorAuthorization } from 'types/sensorAuthorization';

export const TIMESTAMP_FORMAT = 'YYYY-MM-DD-HH';
export const HOURS_AGO = 6;
export const RATE_LIMIT_ISSUE_THRESHOLD = 50;

export function calculateRateLimitCount(sensor: SensorAuthorization) {
  const rateLimitHourlyBuckets =
    sensor?.profile?.rate_limit_errors_hourly_buckets;

  if (isEmpty(rateLimitHourlyBuckets)) {
    return 0;
  }

  return Object.entries(rateLimitHourlyBuckets).reduce(
    (result, [timestampString, value]) => {
      const timestamp = moment(timestampString, TIMESTAMP_FORMAT, true).utc();
      const now = moment.utc();

      if (now.diff(timestamp, 'hours') <= HOURS_AGO) {
        return result + value;
      }

      return result;
    },
    0
  );
}

/**
 * Counts the number of rate limit issues for a list of git integrations
 */
export function useSensorAuthRateLimitCounts(
  sensorAuthorizations: SensorAuthorization[] = []
) {
  return useMemo(() => {
    return sensorAuthorizations.map(calculateRateLimitCount);
  }, [sensorAuthorizations]);
}
